module.exports = __webpack_public_path__ + "40835091b608a5886237ab358b6e447f.glb";